import '../../index.html';
import '../../data/index.html';
import '../../product/index.html';
import '../../about/index.html';

import IntroBlocks from './introBlocks';
import Content from './Content';
import Carousel from './Carousel';
import Video from './Video';

function isPage(slug) {
    return document.querySelector(`.page-${slug}`)
}

function ready() {
    if (isPage('home')) {
        IntroBlocks.init();
        const vf = new Video('.background');
        vf.init();
    }

    if (isPage('data')) {
        const c = new Content();
        c.load('data');
    }

    if (isPage('product')) {
        const c = new Content();
        c.load('product');
    }

    Carousel.init();
}

document.addEventListener('DOMContentLoaded', ready)



// WEBPACK FOOTER //
// ./assets/js/main.js